"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("./graphql");
const exception_1 = require("@almservices-cl/exception");
class HistoryApi {
    constructor(client) {
        this.client = client;
        this.getHistory = async (memberId) => {
            try {
                const apiHistory = await this.client.fetch("getMemberHistory", graphql_1.getHistory, {
                    memberId,
                });
                return {
                    items: apiHistory.memberHistory.events.map(this.apiItemToItem),
                };
            }
            catch (e) {
                if (e instanceof Error) {
                    throw new exception_1.NetworkException(e.message);
                }
                throw Error("Uncaught error: fetching member history");
            }
        };
        this.getHistoryAfter = async (memberId, afterEventId) => {
            try {
                const apiHistory = await this.client.fetch("getMemberHistoryAfter", graphql_1.getHistory, {
                    memberId,
                    after: afterEventId,
                });
                return {
                    items: apiHistory.memberHistory.events.map(this.apiItemToItem),
                };
            }
            catch (e) {
                if (e instanceof Error) {
                    throw new exception_1.NetworkException(e.message);
                }
                throw Error("Uncaught error: fetching member history (after event)");
            }
        };
        this.apiItemToItem = (item) => {
            if (item.nextBudget) {
                return {
                    ...this.adaptCommonEventProperties(item),
                    prevBudget: item.prevBudget,
                    nextBudget: item.nextBudget,
                };
            }
            return this.adaptCommonEventProperties(item);
        };
        this.adaptCommonEventProperties = (item) => {
            var _a;
            return {
                id: item.id,
                name: item.name,
                origin: item.origin,
                createdAt: ((_a = item.dateTime) === null || _a === void 0 ? void 0 : _a.iso8601) || null,
            };
        };
    }
}
exports.default = HistoryApi;
//# sourceMappingURL=History.js.map